import React, { lazy } from 'react';

const PrivacyPolicy = lazy(() => import('./PrivacyPolicy'));

export { PrivacyPolicy }